module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Blueberry.3474d281.pdf";